<template>
  <div class="scroll-device status_page">
    <div v-if="statusApiCallDone">
      <!-- <span>Number of registrations by status</span> -->
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 horizontal_legend" id="legend2" v-if="statusApiCallDone">
      <span class="key_dot legend_ul"></span>
      <span class="legend_name">UL</span>
      <span class="key_dot legend_self"></span>
      <span class="legend_name">SELF</span>
      <span class="key_dot legend_others"></span>
      <span class="legend_name">OTHERS</span>
      <!-- <span class="key_dot legend_expired"></span>
      <span class="legend_name">Expired</span> -->
    </div>
    <div id="pieDiv"></div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import * as d3 from 'd3v4';
import Loader from '../UIComponents/Loader.vue';
import { getChartsDataOverView } from '../../apis/reports';

export default {
  components: {
    Loader,
  },
  data() {
    return {
      certificates: 'Declarations',
      mode: 'reports',
      importPercentage: 0,
      statusApiCallDone: false,
      errors: [],
      registrationdata: [],
      data: [
        { status: 'UL', count: 0 },
        { status: 'Self', count: 0 },
        { status: 'Others', count: 0 },
      ],
      loaderStatus: false,
      posx: 0,
      posy: 0,
      language: ''
    };
  },
  ready() {
    window.addEventListener('resize', this.drawPieChart);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawPieChart);
    socket.removeAllListeners(
      `alertGetChartsEvent_${localStorage.getItem('userId')}`,
    );
  },
  methods: {
    translateData() {
      this.total_data.forEach((item) => {
        if (this.language === 'Portuguese' && item.status !== 'UL') {
          item.status = item.status === 'Self' ? 'Auto' : 'Outras';
        } else if (this.language === 'English' && item.status !== 'UL') {
          item.status = item.status === 'Auto' ? 'Self' : 'Others';
        }
      });
      console.log('lanf', this.language, this.total_data);
    },
    updateImportProgressStatus() {
      this.loaderStatus = false;
      this.importPercentage = 0;
    },
    async loadPieChart() {
      this.loaderStatus = true;
      this.registrationdata = [];
      this.registrationdata = await getChartsDataOverView();
      this.data.forEach((curData) => {
        if (curData.status === 'UL') {
          if (!this.registrationdata?.managedBy?.UL) {
            curData.count = 0;
          } else {
            curData.count = this.registrationdata.managedBy.UL;
          }
        }
        if (curData.status === 'Self') {
          if (this.registrationdata.managedBy.Self === undefined) {
            curData.count = 0;
          } else {
            curData.count = this.registrationdata.managedBy.Self;
          }
        }
        if (curData.status === 'Others') {
          if (this.registrationdata.managedBy.Others === undefined) {
            curData.count = 0;
          } else {
            curData.count = this.registrationdata.managedBy.Others;
          }
        }
      });
      this.total_data = this.data.filter((item) => item.count !== 0);
      if (this.$i18n.locale === 'Portuguese' && this.total_data.length) {
        this.translateData();
      }
      this.statusApiCallDone = true;
      this.drawPieChart();
    },

    drawPieChart() {
      const color = d3
        .scaleOrdinal()
        .range(['#FFBE2C', '#D0922A', '#CF5F28']);
      const legendRectSize = 12;
      const legendSpacing = 4;

      // d3.select('#pieDiv')
      //   .append('div')
      //   .attr('class', 'toolTip');
      // const parentWidth = this.$el.clientWidth;

      // const tooltip = d3.select('#pieDiv').append('div')
      //   .attr('class', 'tooltip')
      //   .style('opacity', 0)
      //   .style('position', 'absolute');

      // const margin = {
      //   top: 10,
      //   right: 20,
      //   bottom: 10,
      //   left: 20,
      // };
      const width = 215;
      const height = 215;
      const radius = Math.min(width, height) / 2;
      const arc = d3.arc()
        .outerRadius(radius)
        .innerRadius(85);
      d3.arc()
        .outerRadius(radius - 20)
        .innerRadius(radius - 20);
      const pie = d3
        .pie()
        .sort(null)
        .value((d) => d.count)
        .padAngle(0.04);

      const svg = d3
        .select('#pieDiv')
        .append('svg')
        .attr('id', 'pieChart')
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('viewBox', () => {
          if (window.screen.width >= 768) {
            return '0 10 360 330';
          }
          if (window.screen.width < 768) {
            return '0 0 300 290';
          }
          return '';
        })
        .attr('preserveAspectRatio', 'xMinYMin')
        .append('g')
        .attr(
          'transform',
          `translate(${Math.min(width, height) / 1.6},${Math.min(
            width,
            height,
          ) / 1.6})`,
        );
      if (this.total_data.length > 0) {
        svg.append('circle')
          .attr('cx', 0)
          .attr('cy', 0)
          .attr('r', radius - 20)
          .attr('fill', '#ffffff');
      }
      const g = svg
        .selectAll('.arc')
        .data(pie(this.total_data))
        .enter()
        .append('g')
        .attr('class', 'arc');
        // .attr('fill', '#f2f2f2');
      // .attr('stroke', '#fff')
      // .attr('stroke-width', '5');
      // .on('mouseover', (d) => {
      //   tooltip.html(d)
      //     .style('left', '100px')
      //     .style('top', '100px');
      // })
      // .on('mouseout', () => {
      //   tooltip.transition().duration(500).style('opacity', 0);
      // });
      // .on('mouseover', (d) => {
      //   d3.select('#tooltip')
      //     .style('left', '100px')
      //     .style('top', '100px')
      //     .style('opacity', 1)
      //     .select('#value')
      //     .text(d.value);
      // });

      // append ticks to the arc
      // const ticks = svg
      //   .selectAll('line')
      //   .data(pie(this.total_data))
      //   .enter()
      //   .append('line');
      // ticks
      //   .attr('x1', 0)
      //   .attr('x2', 0)
      //   .attr('y1', -radius + 4 - 4)
      //   .attr('y2', -radius - 2 - 6)
      //   .attr('stroke', (d) => {
      //     if (d.data.count > 0) {
      //       return 'gray';
      //     }
      //     return '#ffffff';
      //   })
      //   .attr(
      //     'transform',
      //     (d) => `rotate(${((d.startAngle + d.endAngle) / 2) * (180 / Math.PI)})`,
      //   );
      g
        .append('path')
        .attr('d', arc)
        .attr('data-legend', (d) => d.data.status)
        .style('fill', (d) => color(d.data.status));
      // .on('mouseover', (d) => {
      //   tooltip.html(`${d.data.value} : ${d.data.count}`)
      //     .style('position', 'absolute')
      //     .style('text-align', 'center')
      //     .style('width', 'auto')
      //     .style('height', 'auto')
      //     .style('padding', '10px')
      //     .style('background', 'rgb(238, 240, 243)')
      //     .style('border-radius', '10px')
      //     .style('left', `${this.posx}px`)
      //     .style('top', `${this.posy}px`)
      //     .style('opacity', 1)
      //     .style('font-size', '15px');
      // console.log(`${d3.event.pageX}px`, `${d3.event.pageY}px`);
      // console.log(d);
      // console.log(`${d3.select(this).attr('cx')}px`);
      // const pos = d3.event.currentTarget;
      // console.log(pos);
      // console.log(d3.event.clientX, d3.event.clientY);
      // })
      // .on('mousemove', (e, d) => {
      //   tooltip.html(d.data.value).style('top', `${e.pageY - 50}px`)
      //     .style('left', `${e.pageX - 50}px`);
      //   console.log('coord', e.pageX, e.pageY);
      // })
      // .on('mouseout', () => {
      //   tooltip.transition().duration(500).style('opacity', 0);
      // });
      g.append('text')
        .attr('transform', (d) => {
          let dist = '';
          if (d.data.status === 'Self') {
            dist = radius + 10;
          } else { dist = radius + 20; }
          const winkel = (d.startAngle + d.endAngle) / 2;
          const x = dist * Math.sin(winkel);
          const y = -dist * Math.cos(winkel);
          return `translate(${x},${y + 1})`;
        })

        .attr('text-anchor', 'middle')
        .style('font-family', 'Open Sans')
        // .style('display', 'none')
        // .style('font-size', '14px')
        // .style('font-weight', '300')
        // .style('line-height', '20px')
        .attr('dy', '1.0000em')
        .attr('fill', '#3E3E3E')
        .text((d) => (d.data.count > 0 ? d.data.count : ''));

      const legend = svg
        .selectAll('.legend')
        .data(color.domain())
        .enter()
        .append('g')
        .attr('class', 'legend_svg')
        .attr('transform', (d, i) => {
          const hei = legendRectSize + legendSpacing;
          const offset = hei * color.domain().length;
          let horz = width / 0.95;
          if (window.innerWidth > 1024 && window.innerWidth < 1200) {
            horz = width / 3.5;
          }
          // if (window.screen.innerWidth > 1300 && window.screen.innerWidth < 1366) {
          //   horz = width / 1.4;
          // }
          // horz = 145;
          // let temp = i;
          // if (temp === 1) { temp = 0; horz = 282; }
          // const vert = temp === 2 ? 2.5 * temp * hei - offset * 2 : 2.5 * temp * hei - offset * 1.5;
          horz = 210;
          const vert = 2.5 * i * hei - offset * 1.5;

          // console.lo('ver', vert + 100);
          return `translate(${horz},${vert})`;
        });

      legend
        .append('rect')
        .attr('width', legendRectSize + 7)
        .attr('height', legendRectSize + 7)
        .style('fill', color)
        .style('stroke', color);

      legend
        .append('text')
        .style('font-size', '14px')
        .style('font-weight', '400')
        .style('line-height', '19px')
        .attr('fill', 'rgba(0, 0, 0, 0.87)')
        .attr('dy', '0.8750')
        .attr('x', legendRectSize + legendSpacing + 18)
        .attr('y', legendRectSize - legendSpacing + 9)
        .attr('test', (d) => d)
        .text((d) => d);

      g.append('svg:text')
        .attr('dy', '1.1250em')
        .attr('text-anchor', 'middle')
        .attr('style', 'padding-bottom:10px')
        .attr('font-size', '40')
        // .attr('fill', '#5CB85C')
        .attr('transform', 'translate(0,-48)')
        .text(`${this.data[0].count + this.data[1].count + this.data[2].count}`);

      // g.append('svg:text')
      //   .attr('dy', '0.8750em')
      //   .attr('text-anchor', 'middle')
      //   .attr('style', 'padding-bottom:10px')
      //   .attr('font-size', '14')
      //   .attr('font-weight', '300')
      //   .attr('fill', '#333333')
      //   .attr('transform', 'translate(0,5)')

      //   .text('Total');

      g.append('svg:text')
        .attr('dy', '0.8750em')
        .attr('text-anchor', 'middle')
        .attr('font-size', '14')
        .attr('font-weight', '300')
        .attr('line-height', '20')
        .attr('font-family', 'Open Sans')
        .attr('font-style', 'normal')
        .attr('fill', '#333333')
        // .attr('text-wrap', '5')
        .attr('transform', 'translate(0,15)')

        // .attr('fill', '#5CB85C')
        .text(`${this.certificates}`);

      this.loaderStatus = false;
    },
    // mouseover(event) {
    //   const bounds = document.getElementById('pieDiv').getBoundingClientRect();
    //   this.posx = event.clientX - bounds.left;
    //   this.posy = event.clientY - bounds.top;
    // },
  },
  created() {
    this.language = localStorage.getItem('language');
    socket.on(`alertGetChartsEvent_${localStorage.getItem('userId')}`, (data) => {
      this.importPercentage = data;
    });
  },
  async mounted() {
    if (this.language === 'Portuguese') {
      this.certificates = 'Declarações';
    } else {
      this.certificates = 'Declarations';
    }
    await this.loadPieChart();
    window.addEventListener('mousemove', this.mouseover);
  },
};
</script>
<style scoped>
.legend_ul {
  background-color: rgba(255, 190, 44, 1)
}

.legend_self {
  background-color: rgba(208, 146, 42, 1)
}

.legend_others {
  background-color: rgba(207, 95, 40, 1);
}

#pieDiv {
  height: 220px;
  padding-top: 0;
  margin-top: 30px;
}

#pieDiv>div.tooltip {
  position: absolute;
  text-align: center;
  width: 150px;
  height: 80px;
  padding: 10px;
  font: 20px 'Open Sans';
  background: rgb(238, 240, 243);
  border: 0px;
  border-radius: 8px;
  pointer-events: none;
}

#pieDiv>svg.legend_svg {
  margin-top: 20px;
}

@media (min-width: 1025px) {
  .pie-chart {
    width: 40%;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .pie-chart {
    width: 70%;
  }
}

@media (max-width: 767px) {
  .horizontal_legend {
    margin-left: 0px;
    padding-top: 0px;
    width: 103%;
  }
}
@media only screen and (min-width: 1301px) and (max-width: 1366px) {
  .scroll-device {
      padding-left: 0px !important;
    }
}

.status_page .horizontal_legend {
  text-align: left;
}

.scroll-device {
  /* padding-left: 10%; */
}
</style>
